import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import boxes from './boxes/sagas';
import header from './header/sagas';
import user from './user/sagas';
import admin from './admin/sagas';
import insights from './insights/sagas';

export default function* rootSaga() {
  yield all([auth, boxes, header, user, admin, insights]);
}
